// theme constant
export const gridSpacing = 3;
export const drawerWidth = 260;
export const drawerWidthDocs = 290;
export const appDrawerWidth = 320;
export const s3UrlCoinImage = 'https://s3.ap-southeast-1.amazonaws.com/tvn.payme/images/coins';
